import React, { forwardRef, ReactNode } from 'react'
import styles from './DropDown.module.css'

type DropDownPropsType = {
  open: boolean
  ref?: any
  className?: string
  children?: ReactNode
  style?: React.CSSProperties
}

// eslint-disable-next-line react/display-name
const DropDown = forwardRef<HTMLDivElement, DropDownPropsType>((props, ref) => {
  const { open, className, children, style } = props
  return (
    <div
      ref={ref}
      className={`${styles.dropDownMenu} ${open ? styles.active : styles.inactive} ${className}`}
      onClick={(e) => e.stopPropagation()}
      style={style}
    >
      {children}
    </div>
  )
})

export default DropDown
